<div class="sidenav" id="sidenav">
    <a *ngFor="let sn of social_networks; index as i" [href]="sn.href" target="_blank">
        <img id="img-sidenav{{i}}" [src]="sn.img_src" alt="">
    </a>
</div>